import type { ReactNode } from 'react';

import type { DensityProps } from '../types';

/**
 * Density setting for row height.
 *
 * @example
 * ```tsx
 * <DataTable.Density value="compact" />
 * ```
 */
export const Density = (_props: DensityProps): ReactNode => {
  return null;
};

Density.displayName = 'DataTable.Density';
